<template>
  <div class="home">
    <div>
      <div>
        <section>
          <div class="py-8 px-8">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0 me-2">{{$t('cash_register')}}</h4>
                </div>
              </div>
            </div> 
          </div>
        </section>
      </div>
      
      <section class="">
        <div class="px-8">
          <div class="row">
            <div class="col-sm-7"></div>
            <div class="col-sm-2">
              <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select" style="margin-bottom:1rem">
                <option value="">{{$t('filter_by_date')}}</option>
                <option value="today">{{$t('today')}}</option>
                <option value="yesterday">{{$t('yesterday')}}</option>
                <option value="this_week">{{$t('this_week')}}</option>
                <option value="last_week">{{$t('last_week')}}</option>
                <option value="this_month">{{$t('this_month')}}</option>
                <option value="custom">{{$t('custom_date')}}</option>
              </select>
            </div>
            <div class="col-sm-2" v-if="dateRangeOption === 'custom'">
              <date-picker :clearable="true" :editable="false" style="margin-bottom:1rem;width:100%" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
            </div>
            <div class="col-sm-3" style="text-align:right" >
                <button class="btn w-100" :class="currentRegister.status === 'open' ? 'btn-danger' : 'btn-success'" @click="showRegisterModal">
                  {{ currentRegister.status === 'open' ? $t('close_cash_register') + ' ' + formatDateTime(currentRegister.opened_at) : $t('open_cash_register') }}
                </button>
            </div>
          </div>

          <div class="page-table-container mb-6 bg-white rounded shadow">
            <!-- table -->
            <div class="table-responsive">
              <table class="table mb-0 table-borderless table-striped small">
                <thead>
                  <tr class="text-secondary">
                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCashRegisters)" />
                    <sortable-table-header field="opening_balance" label="opening_balance" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCashRegisters)" />
                    <sortable-table-header field="closing_balance" label="closing_balance" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCashRegisters)" />
                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCashRegisters)" />
                    <th class="pt-4 pb-3 px-6">{{$t('cashier')}}</th>
                    <sortable-table-header field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCashRegisters)" />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in cashRegisters" :key="item.id">
                    <td class="py-5 px-6">
                                <router-link :to="{ path: `/pos-cash-registers/${item.id}` }" style="cursor: pointer;"><b>{{item.reference}}</b></router-link>
                            </td>
                    <td class="py-5 px-6">{{formatMoney(item.opening_balance)}}</td>
                    <td class="py-5 px-6">{{item.closing_balance ? formatMoney(item.closing_balance) : '-' }} </td>
                    <td class="py-5 px-6">
                      <span v-if="item.status === 'open'" class="badge bg-info">{{item.status}}</span>
                      <span v-else class="badge bg-success">{{$t(item.status)}}</span>
                    </td>
                    <td class="py-5 px-6">{{ item.cashier?.name || item.cashier?.email || '-' }}</td>
                    <td class="py-5 px-6">{{formatDate(item.created_at)}}</td>
                  </tr>
                </tbody>
              </table>
              <div v-if="count > cashRegisters.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                <compact-pagination :pages="pagination" :current-page="page" @change="getCashRegisters" />
              </div>
            </div>
            <!-- table -->
            <table-loading-bar v-if="loading" class="page-table-state text-center" />
            <div v-if="loading === false && !cashRegisters.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
              <AppIcon name="bi-cash-coin" class="bi bi-cash-coin text-muted" style="font-size: 3rem;" />
              <h4 class="mt-3">{{ $t('no_cash_registers_added') }}</h4>
              <p class="text-muted">{{ $t('start_by_opening_cash_register') }}</p>
              <button class="btn btn-outline-primary mt-2" @click="showRegisterModal">
                <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-2" />{{ $t('open_cash_register') }}
              </button>
            </div>
            <div v-if="loading === false && !cashRegisters.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_cash_registers_found')}}.</div>
          </div>

          <div class="col-sm-7">
            {{$t('show')}}
            <select v-model="per_page" class="form-select mb-3" name="Results" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            {{$t('entities')}}
          </div>
        </div>
      </section>
    </div>

        <cash-register-modal  
      v-if="isModalOpen" 
      :isModalOpen="isModalOpen"  
      @modalClosed="isModalOpen = false" 
      ref="cashRegisterModal"  />

  </div>
</template>

<script>
import helper from '../../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import CashRegisterModal from './PosCashRegister.vue'; // Import the new component
import sortableList from '../../mixins/sortableList'

export default {
  name: 'CashRegisters',
  persistedFilterState: {
    key: 'cash-registers',
    fields: ['search', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components: {
    DatePicker,
    CashRegisterModal
  },
  data() {
    return {
      search: '',
      cashRegisters: [],
      count: 0,
      page: 1,
      pagination: [],
      range: [],
      start: null,
      end: null,
      dateRangeOption: '',
      loading: false,
      per_page: 25,
      url: '',
      isModalOpen : false,
      currentRegister: {
        status: 'closed',
        opened_at: null
      }
    }
  },
  created(){
      this.fetchCurrentRegister()
  },
  mounted() {
    window.mixpanel.track("cash_registers");
    if(helper.checkAccess('view_pos_cash_registers') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_pos_cash_registers') == -2) return this.$router.push({path : '/subscribe'})

    // Initialize this_month date range
    // this.handleDateRangeChange()

    this.getCashRegisters()
  },
  methods: {
    async fetchCurrentRegister() {
      try {
        this.loading = true;
        // Uncomment this when your API is ready:
        const response = await helper.customGet(`${process.env.VUE_APP_API}/cash-register`);
        if (response.data && response.data.id) {
          this.currentRegister = response.data;
        } else {
          this.resetRegister();
        }
        
        this.loading = false;
      } catch (error) {
        this.resetRegister();
        this.loading = false;
      }
    },
    resetRegister() {
      this.currentRegister = {
        opening_balance: 0,
        closing_balance: 0,
        status: 'closed',
        opened_at: null,
        closed_at: null,
        cashier_id: null,
        notes: ''
      };
      this.totalSales = 0;
      this.transactionCount = 0;
    },
    formatMoney(number) { return helper.formatMoney(number);},
    async deleteRow(row) {
      const result = await this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      })
      if (result.isConfirmed) {
        await helper.customDelete(`${process.env.VUE_APP_API}/cash-registers/${row.id}`)
        this.cashRegisters = helper.withoutDeletedRecords(this.cashRegisters, row.id)
        this.count = Math.max(0, this.count - 1)
      }
    },
    async getCashRegisters(page) {
      try {
        this.loading = true
        this.page = page ? page : 1
        this.cashRegisters = this.page == 1 ? [] : this.cashRegisters
        const params = new URLSearchParams({ page: this.page, per_page: this.per_page })
        this.appendSortParams(params)
        if (this.start) {
          params.append('start', this.start)
          params.append('end', this.end)
        }
        
        this.cashRegisters = []

        if(this.search != ""){
          params.append('keyword', this.search)
        }
        const url = `${process.env.VUE_APP_API}/cash-registers?${params.toString()}`
        const response = await helper.customGet(url)
        this.cashRegisters = response.data.data
        if(this.per_page != response.data.per_page){
          this.per_page = response.data.per_page
        }

        this.page = response.data.current_page
        this.count = response.data.count
        this.loading = false

        this.pagination = []
        let MaxPagination = Math.ceil(this.count / this.per_page)
        for(let i = 1; i <= MaxPagination; i++){
          this.pagination.push(i)
        }
      } catch(error) {
        this.loading = false
      }
    },
    showRegisterModal(){
      this.isModalOpen = true
    },
    formatDateTime(dateTime) {
      return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
    },
    formatDate(date) { return helper.formatDate(date) },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        this.range = []
        this.start = null
        this.end = null
        this.getCashRegisters()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        this.range = []
      }
    }
  },
  watch: {
    async search() {
      if(this.search.length > 2){
        try {
          this.loading = true
          const response = await helper.customGet(`${process.env.VUE_APP_API}/cash-registers?keyword=${this.search}`)
          this.cashRegisters = response.data.data
          this.count = response.data.count
          this.loading = false
        } catch(error) {
          this.loading = false
        }
      }
      if(this.search == '') return this.getCashRegisters()
    },
  
   isModalOpen(){
      if(this.isModalOpen === false){
        this.orderConfirmed = false;
        this.fetchCurrentRegister()
        this.getCashRegisters()
      }
    },
    range() {
      if(this.range[0] == null){
        this.start = null
        this.end = null
        this.getCashRegisters()
      }

      if(this.range.length && this.range[0] && this.range[1]){
        this.start = moment(this.range[0]).format('YYYY-MM-DD')
        this.end = moment(this.range[1]).format('YYYY-MM-DD')
        this.getCashRegisters()
      } else {
        this.cashRegisters = []
      }
    },
    per_page() {
      this.getCashRegisters(this.page)
    }
  },
  computed: {
    isFiltered() {
      return (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.search && this.search.length > 0) ||
             (this.range && this.range.length > 0);
    },
    business() { return this.$store.getters.BUSINESS }
  }
}
</script>

<style scoped>
.table-borderless>:not(caption)>*>*{
  padding: 5px !important
}
</style>
